export default __webpack_public_path__ + "static/media/maintenance.5cb8a0ad.svg";